import React from 'react';

const LanguageSwitcher: React.FC = () => null;
export default LanguageSwitcher;
